
<template>
  <div>
    <dialogWrap
      title="新增账户"
      width="824px"
      v-model="isShowDialog"
      class="dialogWrap-box"
      :before-close="closeAddDialog"
    >
      <el-form
        ref="addAccount"
        :model="accountData"
        label-width="120px"
        :rules="rules"
      >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="账户类型"
              >
                <el-input
                  v-model="accountTypeDict[accountData.accountType]"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                prop="accountName"
                :label="'账户名称' + columnSeparator"
              >
                <el-input
                  v-model="accountData.accountName"
                  placeholder="请输入"
                  clearable
                  maxlength="64"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="bankAccountNo"
                :label="'开户账号' + columnSeparator"
              >
                <el-input
                  v-model="accountData.bankAccountNo"
                  placeholder="请输入"
                  clearable
                  v-number:integer.noTrim="19"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="bankName" :label="'开户银行' + columnSeparator">
                <el-input
                  v-model="accountData.bankName"
                  placeholder="请输入"
                  clearable
                  maxlength="64"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="companyName"
                :label="'公司名称' + columnSeparator"
              >
                <el-input
                  v-model="accountData.companyName"
                  placeholder="请输入"
                  clearable
                  maxlength="64"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                prop="creditCode"
                :label="'统一社会信用代码' + columnSeparator"
              >
                <el-input
                  v-model="accountData.creditCode"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                  @input="creditCodeChange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="remarks"
                :label="'备注' + columnSeparator"
                class="alone"
              >
                <el-input
                  type="textarea"
                  v-model="accountData.remarks"
                  placeholder="请输入"
                  maxlength="500"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
      <template slot="footer">
        <el-button size="small" @click="closeAddDialog">取消</el-button>
        <el-button
          :loading="oLoading.add"
          size="small"
          @click="submitAddHandle()"
          type="primary"
          >新增账户</el-button
        >
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import { addAccount } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    optionType: {
      type: Number,
      default: 1, // 1收款单 2付款单
    },
  },
  watch: {
    optionType: {
      handler(val) {
        console.log(val, 'val')
      },
      immediate: true,
    },
  },
  data() {
    return {
      oLoading: {
        add: false,
      },
      accountTypeDict: selectOption.accountTypeDict,
      // 弹窗隐藏显示
      isShowDialog: false,
      accountData: {
        accountType: 1,
        accountName: '',
        companyName: '',
        remarks: '',
        bankAccountNo: '',
        bankName: '',
        creditCode: '',
      },
      rules: {
        accountType: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        accountName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        companyName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    closeAddDialog() {
      this.isShowDialog = false
      this.$refs.addAccount.resetFields()
    },
    creditCodeChange(value) {
      this.accountData.creditCode = value.toUpperCase()
    },
    // 新增、编辑
    submitAddHandle() {
      this.$refs.addAccount.validate((valid) => {
        if (!valid) return
        this.oLoading.add = true
        this.accountData.accountType = this.optionType
        addAccount(this.accountData)
          .then(({ code, data }) => {
            if (code === 1) {
              this.$message.success('操作成功')
              if (data) {
                this.$emit('getAccountId', data)
              }
              this.$refs.addAccount.resetFields()
              this.isShowDialog = false
            }
            this.oLoading.add = false
          })
          .catch(() => {
            this.oLoading.add = false
          })
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-wrap {
  .dialogWrap-box {
    ::v-deep .el-input--small {
      width: 205px;
    }
  }
  .opeartion-box {
    padding-top: 16px;
  }
}
</style>
